import PropTypes from "prop-types";
import { useAuthDataContext } from "components/auth";

const RestrictedToAdmin = ({ excludePartners = false, fallback = null, children }) => {
  const { hasAdminPrivileges, isGlobalAdmin } = useAuthDataContext();
  const showRestrictedComponent = excludePartners ? isGlobalAdmin : hasAdminPrivileges;

  return showRestrictedComponent ? children : fallback;
};

RestrictedToAdmin.propTypes = {
  /**
   * Flag para excluir a los usuarios partner
   */
  excludePartners: PropTypes.bool,
  /**
   * Fallback si el usuario no tiene privilegios de administrador, por defecto null
   */
  fallback: PropTypes.element,
};

export default RestrictedToAdmin;
